(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    class HeaderMenu extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
    }

    connectedCallback() {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      // Prevent click from toggling on desktop
      this.summary.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) {
          e.preventDefault();
          window.location = this.summary.closest('details').querySelector('.mega-menu__link--level-2')?.href || '#';
        }
      });
    }

    onMouseEnter() {
      if (window.innerWidth < 990) return;
      this.details.setAttribute('open', '');
    }

    onMouseLeave() {
      if (window.innerWidth < 990) return;
      this.details.removeAttribute('open');
    }
  }

  if (!customElements.get('header-menu')) {
    customElements.define('header-menu', HeaderMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
